import Joi from 'joi';

export const similarByPatternSettingsValidationSchema = {
  numberOfResultsToDisplay: Joi.number().required().min(3).max(20),
};
